module.exports = "<app-header [tipoMenu]=\"tipoMenuValue\"></app-header>\r\n<app-detalhamento-registro></app-detalhamento-registro>\r\n    "